import { ForwardedRef, forwardRef, useMemo, useState } from 'react';
import { Input, SearchSelectProps } from '~/components/Input';
import { BaseFormState } from '~/types/BaseFormState';
import { ClubListQueryParams, useClubListQuery } from '../queries';

type Props<TFormState extends BaseFormState> = Omit<
  SearchSelectProps<TFormState>,
  'options' | 'search' | 'setSearch' | 'isLoading'
> & {
  query?: Omit<Exclude<ClubListQueryParams, undefined>, 'search' | 'page' | 'page_size'>;
};

function ClubSearchSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLInputElement>
) {
  const [search, setSearch] = useState<string>('');

  const { data, isLoading } = useClubListQuery(
    {
      page_size: 100,
      search,
      ...props.query,
    },
    search.length > 3
  );

  const options = useMemo<[string, number][]>(() => {
    return data?.results.map(({ id, name }) => [name, id]) ?? [];
  }, [data]);

  return (
    <Input.SearchSelect
      aria-label={props['aria-label'] ?? 'Sök förening'}
      setSearch={setSearch}
      isLoading={isLoading}
      options={options}
      search={search}
      ref={ref}
      {...props}
    />
  );
}

export const ClubSearchSelect = forwardRef(ClubSearchSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLInputElement> }
) => ReturnType<typeof ClubSearchSelectElement>;
